import React from 'react';
import AdTypeTile from './AdTypeTile/AdTypeTile';
import './AdTypeSelector.scss';

export default function AdTypeSelector({ setJourney }) {
  return (
    <>
      <h3 className="form-h3">Choose your ad type</h3>
      <div className="form-tile-selector">
        <AdTypeTile
          icon="item"
          heading="Product Sale"
          description="Set up a listing for individual items or multiple products you wish to sell."
          type="product"
          onTileSelected={() => { setJourney('item') }}
        />
        <AdTypeTile
          icon="property"
          heading="Property Listing"
          description="Showcase commercial properties available for purchase or lease."
          type="property"
          onTileSelected={() => { setJourney('property') }}
        />
        <AdTypeTile
          icon="classified"
          heading="Classified Ad"
          description="Promote other offers, services, or opportunities with a general ad."
          type="classified"
          onTileSelected={() => { setJourney('classified') }}
        />
        <AdTypeTile
          icon="job"
          heading="Job Vacancy"
          description="Advertise open positions to reach potential applicants."
          type="job"
          onTileSelected={() => { setJourney('job') }}
        />
      </div>
    </>
  )
}
